import React, { useEffect, useState } from "react";
import { Platform, View } from "react-native";
import * as SplashScreen from "expo-splash-screen";
import * as Updates from "expo-updates";
import { useFonts } from "expo-font";
import Feather from "@expo/vector-icons/Feather";
import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons";
import { Inter_100Thin, Inter_300Light, Inter_400Regular, Inter_500Medium, Inter_700Bold } from "@expo-google-fonts/inter";
import useCurrentUser from "./src/hooks/useCurrentUser";
import useRaygun from "./src/hooks/useRaygun";

SplashScreen.preventAutoHideAsync();

export const FONTS = {
  Inter_100Thin,
  Inter_300Light,
  Inter_400Regular,
  Inter_500Medium,
  Inter_700Bold,
  ...Feather.font,
  ...MaterialCommunityIcons.font,
};

enum ExpoUpdate {
  NOT_LOADED,
  LOADED,
  RELOADED,
}

export default function AppLoader({ children }: { children: React.ReactNode }) {
  const [hasFontsLoaded] = useFonts(FONTS);
  const { loaded: currentUserLoaded } = useCurrentUser();
  const [expoUpdate, setExpoUpdate] = useState(ExpoUpdate.NOT_LOADED);
  useRaygun();

  const appReady = hasFontsLoaded && currentUserLoaded && expoUpdate === ExpoUpdate.LOADED;

  useEffect(() => {
    const checkLoading = async () => {
      if (appReady) {
        await SplashScreen.hideAsync();
      }
    };
    checkLoading();
  }, [appReady]);

  useEffect(() => {
    const checkExpoUpdate = async () => {
      if (!__DEV__ && Platform.OS !== "web") {
        try {
          const { isAvailable } = await Updates.checkForUpdateAsync();
          if (isAvailable) {
            const { isNew } = await Updates.fetchUpdateAsync();
            if (isNew) {
              await Updates.reloadAsync();

              // set expo update to reloaded so we don't call the SplashScreen.hideAsync because it will cause a crash on Android
              setExpoUpdate(ExpoUpdate.RELOADED);
              return;
            }
          }
        } catch (e) {
          console.log(e);
        }
      }

      setExpoUpdate(ExpoUpdate.LOADED);
    };

    checkExpoUpdate();
  }, []);

  return appReady ? <>{children}</> : <View testID="app-loader-view" />;
}
